import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d2a98df0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/notify/_notify.scss?vue&type=style&index=0&id=d2a98df0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a98df0",
  null
  
)

export default component.exports